import { useState, useEffect } from "react";

import API from "utils/api";
import { useUser } from "utils/hooks";

export default function useDashboard(filters = {}) {
  const { token } = useUser();
  const [result, setResult] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    async function fetchDashboard() {
      setLoading(true);

      const { response, data } = await API.fetchDashboard(token, filters);

      if (response.ok) {
        setResult(data);
      }

      setLoading(false);
    }

    fetchDashboard();
  }, [filters]);

  return { result, loading };
}
